{
  "title": "IRON FATHOM",
  "rulesheet": [
    "Complete R-I-G and shoot the hatch to begin a dive.",
    "Build depth with shots, then bank it at the hatch.",
    "Complete four dives and bank 25 depth. Shoot the hatch for Surface."
  ],
  "rulesNotes": [
    "Each of the four dives gets one attempt per game. A timed-out or unfinished dive cannot be retried that game.",
    "The hatch starts a qualified dive when no mode is active. During another mode, it ejects the ball and keeps the next dive qualified."
  ],
  "lighting": {
    "version": 1,
    "palette": {
      "idle": "#FFE0A6",
      "active": "#D4933F",
      "hit": "#FFF0CE",
      "award": "#FFB84A"
    },
    "modes": {
      "diveCold": "#83CBD6",
      "diveSilt": "#CBB887",
      "diveWreck": "#D69C67",
      "diveBlackout": "#AC7EBC",
      "haulUp": "#FFC16A",
      "surface": "#FFE3AC"
    },
    "cues": {
      "jackpot": "jackpot",
      "haulUp": "multiball",
      "surface": "jackpot",
      "banked": "bank",
      "depthBanked": "bank",
      "laneComplete": "bank"
    },
    "paths": {
      "cableRamp": "cableArrow",
      "cableRail": "cableArrow",
      "airliftRamp": "airliftArrow",
      "airliftRail": "airliftArrow"
    }
  }
}
